class _MamGroupsCache {
    constructor() {
        this.storage = {};
    }
    addGroup(message) {
        this.storage[message.userID] = message;
    }
    clear() {
        this.storage = {};
    }
    isInMaMGroupForAccount(account, accountId) {
        var _a;
        const up = (_a = account === null || account === void 0 ? void 0 : account.User) === null || _a === void 0 ? void 0 : _a.Pin;
        const mamGr = this.storage[up];
        if (isNullOrUndefined(mamGr))
            return false;
        const res = mamGr.subAccounts.find((element) => element.accountNumb === accountId);
        return !isNullOrUndefined(res);
    }
}
export const MamGroupsCache = new _MamGroupsCache();
